<template>
  <div>
    <div class="md:hidden fixed bottom-0 left-0 w-full z-[11]">
      <div v-if="acco.url"
        class="shadow-2xl p-4 flex justify-between items-center bg-white dark:bg-neutral-900 border-t border-gray-200 dark:border-neutral-700 dark:text-white w-full mx-auto">
        <a target="_blank" :href="acco.url + '?referrer=' + referrer"
          class="block w-full bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
          <span>{{ $t('Go to website') }}</span>
        </a>
      </div>
      <div v-else
        class="shadow-2xl p-4 flex justify-between items-center bg-white dark:bg-neutral-900 border-t border-gray-200 dark:border-neutral-700 dark:text-white w-full mx-auto"
        @click="openMenu()">
        <div v-if="localPrices.price" class="">
          <div class="booknowbottom">
            <span>€ {{ (localPrices.roomPrice).toFixed(2) }} - {{ $t('Book now!') }}</span>
          </div>
        </div>
        <div class="h-12 flex items-center justify-center w-full">
          <div
            class="block bg-gradient shadow-xl w-full px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
            {{ $t('See availability') }}
          </div>
        </div>
      </div>
    </div>

    <div class="bookingbox h-full dark:text-white" id="bookingbox" :class="{ show: menuOpen }">
      <div class="closebox text-white" @click="closeMenu()">
        <span>+</span>
      </div>
      <div class="inside space-y-3">
        <template v-if="acco && acco.show_book_now">

          <div v-if="!acco.url" class="ablock p-1 relative">
            <svg-vue class="w-6 !h-6 text-primary absolute left-3 top-5" :icon="'calendar'"></svg-vue>
            <HotelDatePicker ref="myDatePicker" class="dark:text-white rounded-lg" :alwaysVisible="false"
              :disabledDates="localUnavailable" :format="dateFormat" :lastDateAvailable="lastDateAvailable"
              :singleDaySelection="isDailyOnly" :showYear="true" :showSingleMonth="false" :minNights="localRoomMinNights"
              :firstDayOfWeek="1" :nextDisabledDate="nextDisabledDate" :selectForward="true"
              :startingDateValue="new Date(checkIn)"
              :endingDateValue="!isDailyOnly ? new Date(checkOut) : new Date(checkIn)" @dayClicked="handleDayClick"
              @period-selected="getSelectedDate" @next-month-rendered="(event) => handleNextMonth(event, true)"
              @previous-month-rendered="(event) => handlePrevMonth(event, true)">
            </HotelDatePicker>
          </div>

          <template v-if="isDailyOnly">
            <div
              class="text-base text-primary flex justify-center items-center gap-2 cursor-pointer transition hover:scale-110 active:scale-95 px-2 rounded-lg border border-primary py-5"
              @click="opencheckoutbox">
              <svg-vue class="w-4 h-4 transition" :class="[latercheckoutopen ? 'rotate-180' : 'rotate-0']"
                icon="chevron-down"></svg-vue>
              <span class="text-xs text-center" v-if="!latercheckoutopen">{{ $t('Book multiple days') }}!</span>
              <span class="text-xs text-center" v-else>{{ $t('One-day booking') }}</span>
            </div>
            <div v-if="latercheckoutopen" class="rounded-lg block p-1 relative">
              <svg-vue class="w-6 !h-6 text-primary absolute left-3 top-5" :icon="'calendar'"></svg-vue>
              <HotelDatePicker ref="checkout" class="dark:text-white rounded-lg" :alwaysVisible="false"
                :disabledDates="localUnavailable" :format="dateFormat" :lastDateAvailable="lastDateAvailable"
                :singleDaySelection="isDailyOnly" :showYear="true" :showSingleMonth="true" :minNights="localRoomMinNights"
                :firstDayOfWeek="1" :nextDisabledDate="nextDisabledDate" :selectForward="true"
                :startingDateValue="new Date(checkOut)" @dayClicked="handleDayClickCheckout"
                @next-month-rendered="(event) => handleNextMonth(event)"
                @previous-month-rendered="(event) => handlePrevMonth(event)">
              </HotelDatePicker>
            </div>
          </template>

          <div v-if="!acco.url && acco.propertyType !== 'Car rental'"
            class="booking_spec_input_box p-4 space-y-2 rounded-lg dark:text-white">
            <div class="input_field">
              <div class="value">
                <span v-if="totalMaxChildren > 0" class="head">{{ $t('Adults') }}</span>
                <span v-else>{{ $t('Guests') }}</span>
                <span v-if="totalMaxChildren > 0" class="text-gray-400 dark:text-neutral-300">{{ $t('18+ years') }}</span>
              </div>
              <div class="input_controls">
                <div class="btn btn-outline-secondary rounded-pill w-10 h-10" :class="numAdult == 1 ? 'disable' : ''"
                  @click="decrementAdult">-</div>
                <input class="bg-transparent w-14" type="number" min="1" :max="totalMaxAdultCombined" :value="numAdult" />
                <div class="btn btn-outline-secondary rounded-pill w-10 h-10"
                  :class="numAdult == totalMaxAdultCombined ? 'disable' : ''" @click="incrementAdult">+</div>
              </div>
            </div>
            <div v-if="totalMaxChildren > 0" class="input_field pt-4">
              <div class="value">
                <span class="head">{{ $t('Children') }}</span>
                <span class="text-gray-400 dark:text-neutral-300">{{ $t('3 - 17 Years old') }}</span>
              </div>
              <div class="input_controls">
                <div class="btn btn-outline-secondary rounded-pill w-10 h-10" :class="numChildren == 0 ? 'disable' : ''"
                  @click="decrementChildren">-</div>
                <input class="bg-transparent w-14" type="number" min="0" :max="totalMaxChildren" :value="numChildren" />
                <div class="btn btn-outline-secondary rounded-pill w-10 h-10"
                  :class="numChildren == totalMaxChildren ? 'disable' : ''" @click="incrementChildren">+</div>
              </div>
            </div>
          </div>

          <div v-if="loadingPrice"
            class="detail_field px-2 text-base dark:text-white rounded-lg py-5 border border-gray-300 dark:border-neutral-600 flex justify-center items-center">
            <div role="status">
              <svg aria-hidden="true" class="w-8 h-8 text-gray-300 dark:text-neutral-700 animate-spin fill-gray-500 dark:fill-neutral-500"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill" />
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else-if="localPrices.price && localPrices.availability != -1"
            class="detail_field px-2 text-base dark:text-white rounded-lg border border-gray-300 dark:border-neutral-600">
            <ul>
              <li class="flex md:flex-col md2:flex-row py-4">
                <span class="md:text-xs md2:text-base">{{ $t('Price') }}</span>
                <span
                  v-if="localPrices.multiplier < 1 || parseFloat(localPrices.originalPrice.toFixed(2)) > parseFloat(localPrices.price.toFixed(2))">
                  € {{ localPrices.originalPrice.toFixed(2) }}
                </span>
                <span v-else>€ {{ localPrices.roomPrice.toFixed(2) }}</span>
              </li>
              <li v-if="localPrices.multiplier < 1"
                class="bg-primary-light border border-primary px-2 py-1 rounded-md mb-4 flex md:flex-col md2:flex-row">
                <span class="md:text-xs md2:text-base">{{ ((1 - localPrices.multiplier) * 100).toFixed(0) }}% {{
                  $t('Discount!') }}</span>
                <span>€ -{{ (localPrices.originalPrice / localPrices.multiplier - localPrices.originalPrice).toFixed(2)
                }}</span>
              </li>
              <li v-else-if="parseFloat(localPrices.originalPrice.toFixed(2)) > parseFloat(localPrices.price.toFixed(2))"
                class="bg-primary-light border border-primary px-2 py-1 rounded-md mb-4 text-primary flex md:flex-col md2:flex-row">
                <span class="md:text-xs md2:text-base">{{ $t('Discount!') }}</span>
                <span>€ -{{ (localPrices.originalPrice - localPrices.price).toFixed(2) }}</span>
              </li>
              <li v-for="(item, index) in obligatoryUpsells" :key="index" class="flex md:flex-col md2:flex-row py-4">
                <span class="md:text-xs md2:text-base">{{ getUpsellLabel(item) }}</span>
                <span>€ {{ getUpsellPrice(item) }}</span>
              </li>
              <li
                class="border-t-2 border-dotted border-gray-400 dark:border-neutral-700 flex md:flex-col md2:flex-row py-4">
                <span class="md:text-xs md2:text-base">{{ $t('Total Price') }}</span>
                <span>€ {{ localPrices.price.toFixed(2) }}</span>
              </li>
            </ul>
          </div>

          <a v-if="acco.url" target="_blank" :href="acco.url + '?referrer=' + referrer"
            class="block bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
            {{ $t('Go to website') }}
          </a>
          <div v-else-if="(acco.use_new_engine && localPrices.availability == -1)" class="errorField rounded-lg">
            {{ $t('Please select other dates') }}
          </div>
          <a v-else-if="(acco.use_new_engine && localPrices.price) || roomCount > 1"
            @click="$emit('buy-conversion', bookingUrl)" :href="bookingUrl" target="_blank"
            class="block bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
            {{ roomCount > 1 ? $t('See options') : $t('Book now') }}
          </a>
          <div v-else-if="acco.use_new_engine && localNotAvailable" class="errorField rounded-lg">
            {{ localNotAvailable ?? $t('something went wrong') }}
          </div>
          <a v-else-if="acco.use_new_engine" @click="$emit('buy-conversion', bookingUrl)" :href="bookingUrl"
            target="_blank"
            class="block bg-gradient shadow-xl px-5 py-5 rounded-lg cursor-pointer hover:scale-95 transition duration-300 active:scale-75 text-white text-center">
            {{ $t('Book now') }}
          </a>
          <div v-else class="errorField rounded-lg">{{ localNotAvailable ?? $t('something went wrong') }}</div>

        </template>
        <div v-else-if="localNotAvailable" class="errorField rounded-lg">
          {{ localNotAvailable ?? $t('something went wrong') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HotelDatePicker from 'vue-hotel-datepicker'
import 'vue-hotel-datepicker/dist/vueHotelDatepicker.css'
import moment from 'moment'
import VueCookies from 'vue-cookies'
const { debounce } = require("lodash");

export default {
  name: 'BookingBox',
  components: { HotelDatePicker },

  props: {
    acco: { type: Object, default: null },
    roomId: { type: [String, Number], default: null },
    roomCount: { type: Number, default: 1 },
    nextDisabledDate: { type: [Date, Number], default: null },
    lastDateAvailable: { type: [Number, Date], default: Infinity },
    menuOpen: { type: Boolean, default: false },
    referrer: { type: String, default: '' },
    homeUrl: { type: String, default: '' },
    // API config
    bmbApi: { type: String, default: '' },
    clientId: { type: String, default: '' },
    propertyId: { type: [String, Number], default: null },
  },

  data() {
    const format = 'YYYY-MM-DD'
    const today = moment()
    return {
      checkIn: VueCookies.isKey('checkin') ? moment(VueCookies.get('checkin')).format(format) : today.clone().add(1, 'days').format(format),
      checkOut: VueCookies.isKey('checkout') ? moment(VueCookies.get('checkout')).format(format) : today.clone().add(3, 'days').format(format),
      checkInTemp: null,
      checkOutTemp: null,
      numAdult: VueCookies.isKey('numAdult') ? Number(VueCookies.get('numAdult')) : 2,
      numChildren: VueCookies.isKey('numChildren') ? Number(VueCookies.get('numChildren')) : 0,
      numAdultTemp: null,
      loadingPrice: false,
      numChildrenTemp: null,
      latercheckoutopen: false,
      htmlLang: document.documentElement.lang.toUpperCase(),
      // local state (previously passed as props)
      localPrices: {},
      localNotAvailable: null,
      localUnavailable: [],
      localRoomMinNights: 1,
      extraCosts: 0,
      getDataCheckin: VueCookies.isKey('checkin')
        ? moment(VueCookies.get('checkin')).startOf('month')
        : today.clone().startOf('month'),
      getDataCheckout: VueCookies.isKey('checkout')
        ? moment(VueCookies.get('checkout')).add(1, 'M').endOf('month')
        : today.clone().add(1, 'M').endOf('month'),
    }
  },

  computed: {
    dateFormat() { return 'YYYY-MM-DD' },
    isDailyOnly() {
      const rooms = this.acco?.rooms
      if (!rooms || typeof rooms !== 'object') return false
      const roomList = Object.values(rooms)
      return roomList.length === 1 && roomList[0].stayUnit === 'day'
    },
    roomList() {
      const rooms = this.acco?.rooms
      if (!rooms || typeof rooms !== 'object') return []
      return Object.values(rooms)
    },
    totalMaxAdult() {
      return this.roomList.reduce((sum, room) => sum + (Number(room.maxAdult) || 0), 0)
    },
    totalMaxPeople() {
      return this.roomList.reduce((sum, room) => sum + (Number(room.maxPeople) || 0), 0)
    },
    totalMaxChildren() {
      return this.roomList.reduce((sum, room) => sum + (Number(room.maxChildren) || 0), 0)
    },
    totalMaxAdultCombined() {
      return Math.max(this.totalMaxAdult, this.totalMaxPeople)
    },
    obligatoryUpsells() {
      if (!this.localPrices.upsell) return []
      return Object.values(this.localPrices.upsell).filter(
        item => item.type != 3 && item.type != 1 && item.type != 5 && item.type != 0
      )
    },
    bookingUrl() {
      if (this.roomCount === 1) {
        return `${this.homeUrl}/book/details/?checkin=${moment(new Date(this.checkIn)).format('YYYY-MM-DD')}&checkout=${moment(new Date(this.checkOut)).format('YYYY-MM-DD')}&numAdult=${this.numAdult}&numChildren=${this.numChildren}&setup=${this.roomId}_1_${this.numAdult},${this.numChildren}`
      }
      return `${this.homeUrl}/book?show_props=${this.acco.id}&checkin=${moment(new Date(this.checkIn)).format('YYYY-MM-DD')}&checkout=${moment(new Date(this.checkOut)).format('YYYY-MM-DD')}&numAdult=${this.numAdult}&numChildren=${this.numChildren}`
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.getAvailability()
      this.calculatePrice()
    })
  },

  methods: {
    openMenu() {
      const element = document.getElementById('bookingbox');
      const offset = 100;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({ top, behavior: 'smooth' });
    },

    calculatePrice: _.debounce(function () {
      this.loadingPrice = true;
      this.calculatePriceDebounced()
      this.loadingPrice = false;
    }, 1000),

    async calculatePriceDebounced() {
      if (moment(new Date(this.checkIn)) <= moment(new Date(this.checkOut))) {
        this.localPrices = {};

        if (
          this.checkIn != this.checkInTemp ||
          this.checkOut != this.checkOutTemp ||
          this.numAdultTemp != this.numAdult ||
          this.numChildrenTemp != this.numChildren || 1
        ) {
          this.checkInTemp = this.checkIn
          this.checkOutTemp = this.checkOut
          this.numAdultTemp = this.numAdult
          this.numChildrenTemp = this.numChildren

          let url = `${this.bmbApi}/api/${this.clientId}/getPrice/${this.propertyId}`
            + `?checkin=${moment(new Date(this.checkIn)).format('YYYYMMDD')}`
            + `&checkout=${moment(new Date(this.checkOut)).format('YYYYMMDD')}`
            + `&numadult=${this.numAdult}`
            + `&numchildren=${this.numChildren}`

          if (this.roomCount == 1) url += `&roomID=${this.roomId}`

          try {
            let response = await fetch(url, {
              headers: {
                'Content-Type': 'text/plain',
                'Accept-Language': document.documentElement.lang,
              },
            })
            response = await response.json()

            if (Object.keys(response).length == 1) {
              this.localNotAvailable = response.message
            } else {
              this.localNotAvailable = null
            }

            this.localRoomMinNights = response.roomMinNights
            let tempcosts = 0

            for (const item in response.upsell) {
              if (response.upsell[item].type > 1) {
                if (response.upsell[item].period == 1 && response.upsell[item].unit == 1) {
                  tempcosts += Number(response.upsell[item].price)
                    * moment(new Date(this.checkOut)).diff(moment(new Date(this.checkIn)), 'days')
                    * (Number(this.numAdult) + Number(this.numChildren))
                } else {
                  tempcosts += Number(response.upsell[item].price)
                }
              }
            }

            if (tempcosts !== this.extraCosts) this.extraCosts = tempcosts
            if (JSON.stringify(response) !== JSON.stringify(this.localPrices)) this.localPrices = response

          } catch (e) {
            console.error('calculatePrice error', e)
          }
        }
      }
    },

    async getAvailability(forceOpen = false) {
      if (!this.propertyId) return

      if (this.getDataCheckin.isSame(this.getDataCheckout)) {
        this.getDataCheckin = this.getDataCheckout.clone().subtract(2, 'months').startOf('month')
      }

      try {
        const response = await fetch(
          `${this.bmbApi}/api/${this.clientId}/getCalendar?propID=${this.propertyId}&checkin=${this.getDataCheckin.format('YYYY-MM-DD')}&checkout=${this.getDataCheckout.format('YYYY-MM-DD')}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          }
        )
        const data = await response.json()
        this.localUnavailable.push(...data.unavailable)

        if (forceOpen) {
          this.$nextTick(() => {
            console.log("OPEN")
            this.$refs.myDatePicker?.showDatepicker()
          })
        }
      } catch (e) {
        console.error('getAvailability error', e)
      }
    },

    handleNextMonth(event, forceOpen = false) {
      this.getDataCheckin = moment(event).startOf('month')
      this.getDataCheckout = moment(event).endOf('month')
      this.getAvailability(forceOpen)
    },

    handlePrevMonth(event, forceOpen = false) {
      this.getDataCheckin = moment(event).startOf('month')
      this.getDataCheckout = moment(event).endOf('month')
      this.getAvailability(forceOpen)
    },

    opencheckoutbox() {
      this.latercheckoutopen = !this.latercheckoutopen
      if (!this.latercheckoutopen) {
        this.checkOut = this.checkIn
        this.calculatePrice()
      }
    },

    getSelectedDate(event, checkinDate, checkoutDate) {
      this.checkIn = checkinDate
      this.checkOut = checkoutDate
      VueCookies.set('checkin', moment(checkinDate).format('YYYYMMDD'))
      VueCookies.set('checkout', moment(checkoutDate).format('YYYYMMDD'))
      this.calculatePrice()
    },

    handleDayClick(event, date) {
      if (this.isDailyOnly && !this.latercheckoutopen) {
        this.checkIn = date
        this.checkOut = date
        this.calculatePrice()
      }
    },

    handleDayClickCheckout(event, date) {
      if (this.isDailyOnly) {
        this.checkOut = date
        this.calculatePrice()
      }
    },

    getUpsellLabel(item) {
      return item.description?.[this.htmlLang] || item.description?.['EN'] || item.description?.['en'] || ''
    },

    getUpsellPrice(item) {
      if (item.period == 1 && item.unit == 1) {
        return (Number(item.price) * moment(new Date(this.checkOut)).diff(moment(new Date(this.checkIn)), 'days') * (this.numAdult + this.numChildren)).toFixed(2)
      }
      return Number(item.price).toFixed(2)
    },

    incrementAdult() {
      this.loadingPrice = true;
      if (this.numAdult < this.totalMaxAdultCombined) this.numAdult++
      VueCookies.set('numAdult', this.numAdult)
      this.calculatePrice()
    },
    decrementAdult() {
      this.loadingPrice = true;
      if (this.numAdult > 1) this.numAdult--
      VueCookies.set('numAdult', this.numAdult)
      this.calculatePrice()
    },
    incrementChildren() {
      this.loadingPrice = true;
      if (this.numChildren < this.totalMaxChildren) this.numChildren++
      VueCookies.set('numChildren', this.numChildren)
      this.calculatePrice()
    },
    decrementChildren() {
      this.loadingPrice = true;
      if (this.numChildren > 0) this.numChildren--
      VueCookies.set('numChildren', this.numChildren)
      this.calculatePrice()
    },
  },
}
</script>